import { useView } from '../app/use-view.ts'
import { ActionHint } from './action-hint.tsx'
import styles from './interaction-prompt.module.css'

/** Below the crosshair: what interact does now, with its key ("Hold" first for a hold). */
export function InteractionPrompt() {
  const prompt = useView((view) => view.hud.prompt)
  if (!prompt) return null

  return (
    <p class={styles.prompt} role="status">
      <ActionHint prompt={prompt} />
    </p>
  )
}
